
type MenuIcon = {
    active?: boolean;
    action?: (param?: any) => void
}


export function BasketIcon({ active = false, action }: MenuIcon) {
    return (
        <svg
            onClick={() => action && action()}
            width="27"
            height="25"
            viewBox="0 0 27 25"


            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3906 1.14062C11.9062 1.42188 12.1406 2.125 11.8594 2.6875L8.01562 10H18.9375L15.0938 2.6875C14.8125 2.125 15.0469 1.42188 15.5625 1.14062C16.125 0.859375 16.8281 1.09375 17.1094 1.60938L21.4688 10H23.1562H25.5H25.875C26.4844 10 27 10.5156 27 11.125C27 11.7812 26.4844 12.25 25.875 12.25H24.9375L22.3125 22.75C21.9844 24.0625 20.7656 25 19.4062 25H7.59375C6.1875 25 5.01562 24.0625 4.64062 22.75L2.0625 12.25H1.125C0.46875 12.25 0 11.7812 0 11.125C0 10.5156 0.46875 10 1.125 10H1.5H3.79688H5.48438L9.84375 1.60938C10.125 1.09375 10.8281 0.859375 11.3906 1.14062ZM4.35938 12.25L6.84375 22.1875C6.9375 22.5156 7.21875 22.75 7.59375 22.75H19.4062C19.7344 22.75 20.0156 22.5156 20.1094 22.1875L22.5938 12.25H4.35938ZM10.5 15.625V19.375C10.5 20.0312 9.98438 20.5 9.375 20.5C8.71875 20.5 8.25 20.0312 8.25 19.375V15.625C8.25 15.0156 8.71875 14.5 9.375 14.5C9.98438 14.5 10.5 15.0156 10.5 15.625ZM13.5 14.5C14.1094 14.5 14.625 15.0156 14.625 15.625V19.375C14.625 20.0312 14.1094 20.5 13.5 20.5C12.8438 20.5 12.375 20.0312 12.375 19.375V15.625C12.375 15.0156 12.8438 14.5 13.5 14.5ZM18.75 15.625V19.375C18.75 20.0312 18.2344 20.5 17.625 20.5C16.9688 20.5 16.5 20.0312 16.5 19.375V15.625C16.5 15.0156 16.9688 14.5 17.625 14.5C18.2344 14.5 18.75 15.0156 18.75 15.625Z" fill="#6E7586" />
        </svg>
    )
}
